type UniqueSuffixFactory = () => string;

const slugifyProjectName = (name: string): string =>
  name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const createUniqueSuffix: UniqueSuffixFactory = () => {
  const uuid = globalThis.crypto?.randomUUID?.();
  if (uuid) return uuid.replace(/-/g, "").slice(0, 12);

  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
};

/**
 * The Project API expects a non-empty ASCII slug, while project names may use
 * any language. Keep the name for display and use an opaque fallback slug
 * whenever transliteration would otherwise produce an empty value.
 */
export const createProjectSlug = (
  name: string,
  createSuffix: UniqueSuffixFactory = createUniqueSuffix,
): string => {
  const slug = slugifyProjectName(name);
  return slug || `project-${createSuffix()}`;
};
